<glxy-form-field bottomSpacing="none" suffixIcon="arrow_drop_down">
  <glxy-label>
    {{ 'FRONTEND.BUSINESSES.ADDRESS_FORM.COUNTRY_REGION' | translate }}
  </glxy-label>
  <input
    matInput
    type="text"
    id="{{ disableAutoFill }}"
    name="{{ disableAutoFill }}"
    autocomplete="{{ disableAutoFill }}"
    [formControl]="control"
    [matAutocomplete]="auto"
    (keydown.Tab)="tabHandler()"
    />
  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    showPanel="true"
    [displayWith]="countryName"
    (optionSelected)="selectCountryOption($event.option?.value)"
    (optionActivated)="activatedOption($event.option?.value)"
    >
    @for (option of filteredCountries$ | async; track option) {
      <mat-option [value]="option">
        {{ option.name }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (control?.errors !== null) {
    <glxy-error>
      {{ 'FRONTEND.BUSINESSES.ADDRESS_FORM.REQUIRED_FIELD' | translate }}
    </glxy-error>
  }
</glxy-form-field>
